/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CriticalNotificationSeverityEnum,
    CriticalNotificationSeverityEnumFromJSON,
    CriticalNotificationSeverityEnumFromJSONTyped,
    CriticalNotificationSeverityEnumToJSON,
} from './CriticalNotificationSeverityEnum';

/**
 * 
 * @export
 * @interface UpdateCriticalNotificationDto
 */
export interface UpdateCriticalNotificationDto {
    /**
     * 
     * @type {CriticalNotificationSeverityEnum}
     * @memberof UpdateCriticalNotificationDto
     */
    severity: CriticalNotificationSeverityEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCriticalNotificationDto
     */
    text: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateCriticalNotificationDto
     */
    activeFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateCriticalNotificationDto
     */
    activeTo: Date;
}

export function UpdateCriticalNotificationDtoFromJSON(json: any): UpdateCriticalNotificationDto {
    return UpdateCriticalNotificationDtoFromJSONTyped(json, false);
}

export function UpdateCriticalNotificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCriticalNotificationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'severity': CriticalNotificationSeverityEnumFromJSON(json['severity']),
        'text': json['text'],
        'activeFrom': (new Date(json['activeFrom'])),
        'activeTo': (new Date(json['activeTo'])),
    };
}

export function UpdateCriticalNotificationDtoToJSON(value?: UpdateCriticalNotificationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'severity': CriticalNotificationSeverityEnumToJSON(value.severity),
        'text': value.text,
        'activeFrom': (value.activeFrom.toISOString()),
        'activeTo': (value.activeTo.toISOString()),
    };
}

